import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-buttons',
  templateUrl: './buttons.component.html'
})
export class ButtonsComponent {
  @Input() showButton = true;

  @Input() buttons: ButtonConfig[] = [];

  constructor() {
  }


  // onClick(action: number) {
  //   
  //   this.ejecutarAccion.emit(action);
  // }

  @ViewChild('fileInput') fileInput!: ElementRef;
  @Output() ejecutarAccion = new EventEmitter<any>(); // cambia a 'any' si emites un objeto

  onClick(action: number): void {

    this.ejecutarAccion.emit(action);
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];


      // Puedes emitir solo la acción
      // this.ejecutarAccion.emit(3);

      // O emitir también el archivo:
      this.ejecutarAccion.emit({ action: 3, file });
    }
  }
}

export interface ButtonConfig {
  label: string;
  icon?: string;          // imágenes (legacy)
  materialIcon?: string;  // NUEVO: material symbols
  action: number;
  bgColor: string;
  disabled?: boolean;
  status?: string;
}

